/* -------------------------------------------------------------------------- */
/* --------------------------- THEME : FRAMEWORKS --------------------------- */

// FRAMEWORKS : NODES_MODULES
import Swiper, { Autoplay, Navigation, Parallax, Scrollbar } from "swiper";
import VanillaTilt from "vanilla-tilt"; 
import { Modal } from 'bootstrap';

// FRAMEWORKS : GSAP BUSINESS
import "../js/gsap-business-green/gsap.min.js";
import "../js/gsap-business-green/EasePack.min.js";
import "../js/gsap-business-green/ScrollSmoother.min.js";
import "../js/gsap-business-green/ScrollTrigger.min.js";
import "../js/gsap-business-green/ScrollToPlugin.min.js";
import "../js/gsap-business-green/DrawSVGPlugin.min.js";
import { SplitText } from "../js/gsap-business-green/SplitText.min.js";

//fluid animation
//import { multipleSplats, update, config, pointers, updatePointerDownData, updatePointerMoveData, updatePointerUpData } from './fluid.js';
// stresstest 
//import { stressTest } from "./pixi/StressTest.js";

/* -------------------------------------------------------------------------- */
/* ------------------------ THEME : GLOBAL VARIABLES ------------------------ */

const debug = false; 
const fullAnim = false;
const elasticsLetters = false;


function isMobile () {
    return /Mobi|Android/i.test(navigator.userAgent);
}
function isHome() {
  if ( document.getElementById('home-hero')) return true;
  else return false
}
//console.log('mobile : ',isMobile());

let splatCount = 10;
let isIntroSplat = true;
let isMouseSplat = true;
if ( isMobile() ) {
  splatCount = 0;
  isMouseSplat = false;
}

/*
let multipleSplats, update, config, pointers, updatePointerUpData, updatePointerDownData, updatePointerMoveData;
if ( isHome() ) {
  //import { multipleSplats, update, config, pointers, updatePointerDownData, updatePointerMoveData, updatePointerUpData } from './fluid.js';
  pointers = require('./fluid.js').pointers;
  update = require('./fluid.js').update;
  updatePointerUpData = require('./fluid.js').updatePointerUpData;
  updatePointerDownData = require('./fluid.js').updatePointerDownData;
  updatePointerMoveData = require('./fluid.js').updatePointerMoveData;
  config = require('./fluid.js').config;
  multipleSplats = require('./fluid.js').multipleSplats
}*/

/*
let st = new stressTest(onStressTestComplete);
function onStressTestComplete()
{
  st.end();
  console.log( 'st : '+st.result );
  if (  st.result  < 48 ) {
    isIntroSplat = false;
    isMouseSplat = false;
    isTransitionSplat = false;
  }
}
*/


function scaleByPixelRatio (input) {
    var pixelRatio = window.devicePixelRatio || 1;
    return Math.floor(input * pixelRatio);
}

// ScrollSmoother (GSAP)
let scrollSmooth = ScrollSmoother.create({
  wrapper: "#page-wrapper",
  content: "#page-main",
  smooth: 1,
  smoothTouch: false,
  effects: true,
  normalizeScroll: false,
  ignoreMobileResize: true,
});
if ( typeof config !== 'undefined' ) {
  const defaultFluidConfig = { ...config };
}

/* -------------------------------------------------------------------------- */
/* ------------------------- THEME : GLOBAL EVENTS -------------------------- */

// DOCUMENT READY :
document.addEventListener("DOMContentLoaded", () => {
  // remove 'no-js' body class
  document.body.classList.remove("no-js");
  
  // Gestion du cache
  sessionStorage.setItem("visited", true);
});
initPage();

// DOCUMENT RESIZED
ScrollTrigger.addEventListener("refreshInit", () => {
  // Actualisation du smooth scroll
  gsapScrollSmootherState("refresh");
  // Actualisation de la bannière
  bannerScrollingDetect();
});


  // Gestion des menus
  headerScrolledMenu(160);
  headerMobileMenu();
  menuItemDropdown();
  // Gestion de la bannière
  bannerClosing();
  bannerScrollingDetect();

/* -------------------------------------------------------------------------- */
/* ----------------------- THEME : GLOBAL FUNCTIONS ------------------------- */

// Détection du scroll
function headerScrolledMenu(scrollOffset) {
  let position = window.pageYOffset;

  if (position > scrollOffset) {
    document.body.classList.add("page-scrolled");
  } else {
    document.body.classList.remove("page-scrolled");
  }

  document.addEventListener("scroll", () => {
    // detect scroll direction
    let scroll = window.pageYOffset;
    if (scroll > position) {
      // if scroll to bottom
      if (scroll < scrollOffset) {
        document.body.classList.remove("page-scrolled");
        document.body.classList.remove("page-scrolling");
      } else {
        document.body.classList.add("page-scrolling");
        document.body.classList.add("page-scrolled");
      }
    }
    // if scroll to top
    else {
      document.body.classList.remove("page-scrolling");
      if (scroll < scrollOffset) {
        document.body.classList.remove("page-scrolled");
      }
    }
    // if scroll max reached
    if (scroll + window.innerHeight >= document.documentElement.scrollHeight) {
      document.body.classList.add("page-scroll-completed");
    } else {
      document.body.classList.remove("page-scroll-completed");
    }
    position = scroll;
  });
}

// Menu Burger : Comportement au clic
function headerMobileMenu() {
  const pageHeaderBurger = document.querySelector(
    "#page-header #page-header-burger"
  );
  const pageHeader = document.querySelector("#page-header");

  pageHeaderBurger.addEventListener("click", () => {
    if (pageHeader.classList.contains("page__header--open")) {
      // Fermer le menu au clic sur le bouton burger
      document.documentElement.style.overflowY = "auto";
      if (scrollSmooth) {
        gsapScrollSmootherState("play");
      }
      pageHeader.classList.remove("page__header--open");
    } else {
      // Ouvrir le menu au clic sur le bouton burger
      document.documentElement.style.overflowY = "hidden";
      if (scrollSmooth) {
        gsapScrollSmootherState("pause");
      }

      pageHeader.classList.add("page__header--open");
    }
  });

  document.addEventListener("mouseup", (event) => {
    // Fermer le menu au clic dehors de la zone
    if (
      !pageHeader.contains(event.target) &&
      event.target !== pageHeader &&
      !event.target.closest("#page-header")
    ) {
      document.documentElement.style.overflowY = "auto";
      if (scrollSmooth) {
        gsapScrollSmootherState("play");
      }
      pageHeader.classList.remove("page__header--open");
    }
  });
}

// Menu Dropdown : Comportement au clic
function menuItemDropdown() {
  const menuItemLinks = document.querySelectorAll(
    '.menu .menu__item .menu__link[href="#"]'
  );

  menuItemLinks.forEach((item) => {
    item.addEventListener("click", (event) => {
      event.preventDefault();
      item.closest(".menu__item").classList.toggle("menu__item--active");
    });
  });

  document.addEventListener("mouseup", (event) => {
    const activeMenuItems = document.querySelectorAll(
      ".menu .menu__item.menu__item--active"
    );

    activeMenuItems.forEach((activeItem) => {
      if (
        !activeItem.isEqualNode(event.target) &&
        !activeItem.contains(event.target)
      ) {
        activeItem.classList.remove("menu__item--active");
      }
    });
  });
}

// Ouverture/Fermeture de la bannière
function bannerClosing() {
  const pageBanner = document.querySelector("#page-banner");
  const pageBannerClose = document.querySelector("#page-banner-close");

  if (pageBanner) {
    // bouton de fermeture
    pageBannerClose.addEventListener("click", () => {
      document.body.classList.remove("page-with-banner");
    });
  }
}

// Activation auto du défilement horizontal
function bannerScrollingDetect() {
  const pageBanner = document.querySelector("#page-banner");

  if (pageBanner) {
    const bannerwrapperWidth = pageBanner.offsetWidth;
    const bannerTextWidth =
      pageBanner.querySelector(".banner__content").offsetWidth;
    if (bannerwrapperWidth > bannerTextWidth + 60) {
      pageBanner.classList.remove("page__banner--scrolling");
    } else {
      pageBanner.classList.add("page__banner--scrolling");
    }
  }
}

// Popup : Comportement au clic
function popupInit() {
  const popups = document.querySelectorAll("[data-popup]");

  popups.forEach((popup) => {
    popup.addEventListener("click", (event) => {
      // event.preventDefault();

      // ouvrir/fermer la popup
      const thisPopupName = popup.dataset.popup;
      if (thisPopupName) {
        const thisPopupEl = document.querySelector(
          `.page__popup#${thisPopupName}`
        );
        thisPopupEl.classList.toggle("page__popup--open");
      }

      // mettre les vidéos des popups en pause
      const htmlVideoFromPopup =
        document.querySelectorAll(".page__popup video");
      if (htmlVideoFromPopup.length > 0) {
        htmlVideoFromPopup.forEach((video) => {
          video.pause();
        });
      }
    });
  });

  document.addEventListener("mouseup", (event) => {
    // si une popup est ouverte
    if (
      document.querySelectorAll(".page__popup.page__popup--open").length > 0
    ) {
      // click en dehors de la zone
      if (
        !document
          .querySelector(".page__popup .popup__wrapper")
          .contains(event.target) &&
        document.querySelector(".page__popup .popup__wrapper") !== event.target
      ) {
        // fermer la popup
        document.querySelectorAll(".page__popup").forEach((popup) => {
          popup.classList.remove("page__popup--open");
        });

        // mettre les vidéos des popups en pause
        const htmlVideoFromPopup =
          document.querySelectorAll(".page__popup video");
        if (htmlVideoFromPopup.length > 0) {
          htmlVideoFromPopup.forEach((popupVideo) => {
            popupVideo.pause();
          });
        }
      }
    }
  });
}

// Toggle : Comportement au clic
function toggleInit() {
  const toggleListener = document.querySelectorAll("[data-toggle]");
  toggleListener.forEach((toggleButton) => {
    toggleButton.addEventListener("click", (event) => {
      // ouvrir/fermer l'accordéon
      let toggleData = toggleButton.dataset.toggle;
      if (toggleData) {
        toggleData = toggleData.split(",");
        let toggleTarget = toggleData.shift();
        if (toggleTarget) {
          // cible
          let toggleTargetEl = document.querySelector(`#${toggleTarget}`);
          if (toggleData) {
            toggleData.forEach(function (className) {
              className = className.trim();
              // ajouter/retirer les classes renseignés
              toggleTargetEl.classList.toggle(className);
            });
          } else {
            // ajouter/retirer la classe ".active"
            toggleTargetEl.classList.toggle("active");
          }
        }
      }
    });
  });
}

// Activation de Swiper.js (sliders)
function allSwiperInit() {
  if (
    document.querySelectorAll(
      ".section-archive-related-news .swiper .swiper-slide"
    ).length > 0
  ) {
    const swiperRelatedNews = new Swiper(
      ".section-archive-related-news .swiper",
      {
        // Core parameters
        slidesPerView: "auto",
        speed: 1200,
        resizeObserver: true,
        // Modules
        modules: [Autoplay, Scrollbar],
        // Modules parameters
        autoplay: {
          delay: 3600,
          disableOnInteraction: true,
        },
        scrollbar: {
          el: ".section-archive-related-news .swiper-scrollbar",
          draggable: true,
        },
      }
    );
  }


  if (
    document.querySelectorAll(
      ".section-hero-single-portfolio .swiper .swiper-slide"
    ).length > 0
  ) {
    const swiperHeroSinglePortfolio = new Swiper(
      ".section-hero-single-portfolio .swiper",
      {
        // Core parameters
        slidesPerView: "auto",
        speed: 1200,
        loop: true,
        resizeObserver: true,
        // Modules
        modules: [Autoplay, Navigation, Parallax],
        // Modules parameters
        autoplay: {
          delay: 2400,
          disableOnInteraction: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        parallax: true,
      }
    );
  }
  if ( document.querySelector('.award-jury__swiper') ) {

    // CURSOR JURY 
      const cursorJurySwiper = document.querySelector('.award-jury__swiper'); 
      const cursorJuryWrapper = cursorJurySwiper.querySelector('.swiper-wrapper');
    
      /*let cursorTl = gsap.timeline({paused: true});
      cursorTl.to(conicCursor,{scale:1,alpha:1,duration:0.4})*/
      cursorJuryWrapper.addEventListener('mouseover',function(){
        conicCursor.querySelector('.conic-cursor__text').innerHTML = cursorJurySwiper.dataset.cursorText;
        cursorTl.play();
        cursorJuryWrapper.addEventListener('mousemove', moveCircle);
      });
      cursorJuryWrapper.addEventListener('mouseout',function(){
          cursorTl.reverse();
      });
    // EOF CURSOR JURY



    const swiper = new Swiper('.award-jury__swiper', {
      modules: [ Navigation ],
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      slidesPerView: 1,
      spaceBetween: 35,
      breakpoints: {
        992: {
          slidesPerView: 2,
          spaceBetween: 35,
        }
      }
    });

    gsap.set('.award-jury__swiper .swiper-slide', { x:'100vw' })
    const juryTl = gsap.timeline({paused:true})
    .to('.award-jury__swiper .swiper-slide',{
      x:0,
      duration:2,
      ease:'Power3.easeOut',
      stagger:0.1
    });
    ScrollTrigger.create({
      trigger:'.award-jury__swiper',
      start:'top 90%',
      toggleActions:"play none none reverse",
      animation:juryTl,
    })
  }

  if ( document.querySelector('.award-timeline__swiper') ) {
    const timelineswiper = new Swiper('.award-timeline__swiper', {
      modules: [ Navigation ],
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      slidesPerView: 1,
      spaceBetween: 0,
      breakpoints: {
        992: {
          slidesPerView: 3,
        }
      }
    });

    gsap.set('.award-timeline__swiper .swiper-slide', { x:'100vw' })
    const juryTl = gsap.timeline({paused:true})
    .to('.award-timeline__swiper .swiper-slide',{
      x:0,
      duration:2,
      ease:'Power3.easeOut',
      stagger:0.1,
      delay:0.3
    });
    ScrollTrigger.create({
      trigger:'.award-timeline__swiper',
      start:'top 90%',
      toggleActions:"play none none reverse",
      animation:juryTl,
    })

  }

}

// État du scrollSmoother plugin
function gsapScrollSmootherState(state) {
  if (scrollSmooth) {
    // Désactiver sur Élémentor
    if (document.querySelector("body.elementor-editor-active")) {
      scrollSmooth.kill();
    }
    // Rafraîchir sinon
    else {
      if (state === "refresh") {
        scrollSmooth.refresh();
      }
      // Mettre en pause
      if (state === "pause") {
        scrollSmooth.paused(true);
      }
      if (state === "play" && scrollSmooth.paused()) {
        scrollSmooth.paused(false);
      }
    }
  }
}

// Scroll vers une ancre
function gsapScrollTo() {
  // avec un [href="#..."]
  const scrollToAnchor = document.querySelectorAll("a[href^='#']");
  scrollToAnchor.forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault();
      let anchorHref = link.getAttribute("href");
      scrollSmooth.scrollTo(anchorHref, true);
    });
  });

  // avec un [data-scrollto]
  const scrollToData = document.querySelectorAll("[data-scrollto]");
  scrollToData.forEach((data) => {
    data.addEventListener("click", () => {
      let anchorData = data.getAttribute("data-scrollto");
      if (anchorData == "auto") {
        anchorData = window.innerHeight + window.scrollY;
      }
      scrollSmooth.scrollTo(anchorData, true);
    });
  });

  // au chargement
  let hashInUrl = window.location.hash;
  if (hashInUrl) {
    scrollSmooth.scrollTo(hashInUrl, true);
  }
}

// Sticky element
/*
function gsapStickyElement() {
  const stickyWrapper = document.querySelector("[data-sticky]");

  if (stickyWrapper) {
    ScrollTrigger.matchMedia({
      // desktop
      "(min-width: 992px)": () => {
        ScrollTrigger.create({
          trigger: stickyWrapper.firstElementChild,
          start: "center center",
          end: () =>
            `+=${
              stickyWrapper.offsetHeight -
              stickyWrapper.firstElementChild.offsetHeight
            }`,
          pin: true,
          pinSpacing: false,
          invalidateOnRefresh: true,
        });
      },
    });
  }
}*/

// Découpage des textes avec SplitText
function gsapSplitText() {
  textsToAnimated.forEach((_thisText) => {
    new SplitText(_thisText, {
      type: "lines, words",//, chars",
      linesClass: "line",
      wordsClass: "word",
      charsClass: "letter",
    });
  });

  new SplitText('#home-hero p', {
    type: "lines, words",
    linesClass: "line",
    wordsClass: "word",
  });

  new SplitText('.partner__title', {
    type: "lines, words",
    linesClass: "line",
    wordsClass: "word",
  });
  
  // hide text to animated
  textsToAnimated.forEach((_this) => {
    const textsLetters = _this.querySelectorAll('.word');
    gsap.set(textsLetters,{
      opacity:0,
      y:100,
    })
  })
}

// Animations avec le ScrollTrigger
function gsapAnimations() {
  // Ajout/retrait de la classe --animated
  elementsToAnimated.forEach((_this) => {
    const delay = _this.getAttribute("data-animation-delay")
      ? parseInt(_this.getAttribute("data-animation-delay"), 10)
      : 0;
    ScrollTrigger.create({
      trigger: _this,
      start: "-=100px +=100%",
      end: "bottom +=0%",
      onEnter: () => {
        setTimeout(() => {
          _this.classList.add("--animated");
        }, delay);
      },
      onLeaveBack: () => {
        _this.classList.remove("--animated");
      },
    });
  });

  // au chargement
  let hashInUrl = window.location.hash;
  if (hashInUrl) {
    scrollSmooth.scrollTo(hashInUrl, true);
  }


  textsToAnimated.forEach((_this) => {

 
    const textsWords = _this.querySelectorAll('.word');
    const textsTl = gsap.timeline({paused:true})
    .to(textsWords,{
      opacity:1,
      y:0,
      duration:0.3,
      ease:'Power2.easeOut',
      stagger:0.03
    })
    ScrollTrigger.create({
      trigger: _this,
      start: "top 90%",
      toggleActions:"play none none reverse",
      animation:textsTl
    });
  });

  document.querySelectorAll('.partner').forEach((_this) => {

    const textsWords = _this.querySelectorAll('.word, .button, .partner__image');
   
    gsap.set(textsWords,{
      opacity:0,
      y:100,
    })
    const partnersTl = gsap.timeline({paused:true})
    .to(textsWords,{
      opacity:1,
      y:0,
      stagger:0.05
    })
    ScrollTrigger.create({
      trigger: _this,
      start: "top 75%",
      toggleActions:"play none none reverse",
      animation:partnersTl
    });
  });

  // if ( document.getElementById('the-content')) {
  //   ScrollTrigger.create({
  //     trigger: "#the-content",
  //     start: "top top",
  //     onToggle: function(self){ 
  //         console.log(self.isActive);
  //        if ( self.isActive) { 
  //         document.querySelector('#gradient-background').pause();
  //       } 
  //        else { 
  //         document.querySelector('#gradient-background').play();
  //       } 
  //       },
  //   });
  // }
  
}

// Preloader (et gestion des animations GSAP)
gsapPreLoader();

// Loader d'accueil
function gsapPreLoader() {
  // Chargement des fonctions GSAP préalables

  if ( debug ) {
    console.log('debug : ', true)
    afterPreloader();
    gsapScrollSmootherState("play");
    gsap.set('#page-preloader',{visibility:"hidden"})
    return;
  }

  // Lancement de l'animation de chargement
  let loaderTimeline = gsap.timeline();
  // Première visite
  if ( !sessionStorage.getItem("visited") || document.querySelector("body.home") ) {
    gsap.set('.page__preloader .progress',{scaleY:0})
    loaderTimeline
      .to(window, {
        scrollTo: 0,
        duration: 0,
      })
      .call(gsapScrollSmootherState, ["pause"])
      .set('.preloader__svg .cls-3',{opacity:0, scaleY:0})
      .set('.preloader__svg .cls-2',{opacity:0, y:-20})
      .set('.preloader__svg .cls-1',{opacity:0, y:20})
      .to("#page-preloader-content", {
        delay: 0.3,
        duration: 0.6,
        ease: "power1.out",
        opacity: 1,
      })
      .to('.preloader__svg .cls-3',{
        scaleY:1,
        opacity:1,
        duration:0.3,
        ease:'Power2.easeIn'
      })
      .to(['.preloader__svg .cls-1','.preloader__svg .cls-2'],{
        y:0,
        opacity:1,
        duration:0.3,
        ease:'Power2.easeIn'
      },'<')
      .to('.page__preloader .progress',{
        scaleY:1,
        duration:1,
        ease:'Power3.easeOut'
      })
      .to('.page__preloader .progress',{
        scaleY:0,
        duration:0.2,
      })
      /*.to('.page__preloader .conic-gradient',{
        scale:0.5,
        duration:0.5,
        ease:'Bounce.easeOut'
      }, '<')*/
      .to('.page__preloader .preloader__background', {
        borderRadius:200,
        width:0,
        height:0,
        left:'50%',
        top:'50%',
      }, '<')
      .to('.preloader__svg', { 
        scale:0 ,
        duration:0.3,
      },'<')
      .to('.page__preloader', {
        scale:0,
        duration:0.3,
        ease:'Power2.easeIn'
      })
    // after
    loaderTimeline.add(afterPreloader, loaderTimeline.duration() - 1.2);
  }
  // Autres
  else {
    gsap.set('.page__article', { opacity:0 })
    gsap.set('.page__preloader .progress',{scaleY:0})
    loaderTimeline
      // animation
      .set('.preloader__svg .cls-3',{opacity:0, scaleY:0})
      .set('.preloader__svg .cls-2',{opacity:0, y:-20})
      .set('.preloader__svg .cls-1',{opacity:0, y:20})
      .to("#page-preloader-content", {
        delay: 0.3,
        duration: 0.3,
        ease: "power1.out",
        opacity: 1,
      })
      .to('.preloader__svg .cls-3',{
        scaleY:1,
        opacity:1,
        duration:0.3,
        ease:'Power2.easeIn'
      })
      .to(['.preloader__svg .cls-1','.preloader__svg .cls-2'],{
        y:0,
        opacity:1,
        duration:0.3,
        ease:'Power2.easeIn'
      },'<')
      .to('.preloader__svg', { 
        scale:0 ,
        duration:0.3,
      },'>+=0.6')
      .to('.page__preloader .preloader__background', {
        borderRadius:200,
        width:0,
        height:0,
        left:'50%',
        top:'50%',
      },'>-=0.1')
      .set('.page__preloader', {
        scale:0,
      })
      .set('.page__article', { y:500 })
      .to('.page__article', { opacity:1, y:0, duration:1 });
    // after
    loaderTimeline.add(afterPreloader, loaderTimeline.duration() - 2.4);
  }
}

// Actions après le Loader d'accueil
function afterPreloader() {
  //config.BLOOM_INTENSITY = 0.2;
  /*
  gsap.to(config, {
    BLOOM_INTENSITY : 0.2,
    BLOOM_THRESHOLD:1,
    DENSITY_DISSIPATION : 2.8,
    VELOCITY_DISSIPATION : 2.1,
    duration:2
  })*/

  // Chargement des fonctions GSAP résultantes
  loadMenu();
  
  if ( isHome() ) {
    if ( isIntroSplat && typeof multipleSplats !== 'undefined' ) multipleSplats(splatCount);
    loadHome();
  } else {
    gsapScrollSmootherState("play");
  }
  setTimeout(function() { loadPage(); } , 1700);
}




// MENU
const menu = document.querySelector('.header__navbar__menu');
let menuRect = menu.getBoundingClientRect().x;
const dotMenu = document.createElement('div');
dotMenu.className = 'dot';
gsap.set(dotMenu,{opacity:0})
menu.append(dotMenu);

document.querySelectorAll('.header__navbar__menu .menu__item').forEach(function(menuItem){
  const menuLink = menuItem.querySelector('a');
  menuLink.addEventListener('mouseover',function(){
    var rect = menuItem.getBoundingClientRect();
    gsap.to(dotMenu, { 
      x:menuItem.offsetLeft + rect.width / 2,
      width:rect.width - 4,
      height:rect.height - 4,
      opacity:1,
      duration:0.4,
      borderRadius:100,
      ease:'Power3.easeOut'
    })
  })
  menuLink.addEventListener('mouseout',function(){
    gsap.to(dotMenu, { 
      width:0,
      borderRadius:0,
      height:10,
      duration:0.4,
      ease:'Power3.easeOut'
    })
  })
})


gsap.set('.header__navbar__brand', { x:-100, opacity:0 })
gsap.set('.header__navbar__burger', { y:-100, opacity:0 })
gsap.set('.language-picker, .header__navbar__menu', { scale:0 })
gsap.set('#menu-social', { opacity:0 })
gsap.set('#menu-social .menu__item', { scale:0 })
function loadMenu() {
  const delay = 2;
  gsap.to('.header__navbar__brand', { x:0, opacity:1, ease:'Power2.easeOut', duration:1, delay:delay })
  gsap.to('.language-picker, .header__navbar__menu', { scale:1, stagger:0.2, ease:'Power2.easeOut', duration:1, delay:delay + 0.2 })
  gsap.to('#menu-social', { opacity:1,  ease:'Power2.easeOut', duration:1, delay:delay + 0.5 })
  gsap.to('#menu-social .menu__item', { scale:1, stagger:0.2, ease:'Power2.easeOut', duration:1, delay:delay + 0.6 })
  gsap.to('.header__navbar__burger', { y:0, opacity:1, ease:'Power2.easeOut', duration:1, delay:delay + 1 })
}







let elementsToAnimated, textsToAnimated;
function initPage(){
  
  // Élèment à animer (en CSS ou JS)
  elementsToAnimated = document.querySelectorAll([
    // global
    "[data-animation]",
    // elementor
    ".page__article .elementor-button-wrapper",
    ".page__article .elementor-heading-title",
    ".page__article .elementor-icon-list-item",
    ".page__article .elementor-icon-wrapper",
    ".page__article .elementor-sitemap-section > *",
    ".page__article .elementor-widget-html",
    ".page__article .elementor-widget-image",
    ".page__article .elementor-widget-nav-menu",
    ".page__article .elementor-widget-text-editor",
    ".page__article .elementor-widget-video",
    ".page__article .elementor-shortcode",
    ".page__article .elementor-heading-title.elementor-size-small",
  ]);
  textsToAnimated = document.querySelectorAll([
    // global
    "[data-animation='reveal-text']",
    ".page__article .elementor-heading-title.elementor-size-default",
    ".big-title"
  ]);



  // Gestion des "data" custom
  popupInit();
  toggleInit();
  // Gestion des sliders
  allSwiperInit();

  gsapScrollTo();
  allSwiperInit();
  gsapSplitText();
  //gsapStickyElement();

  if ( document.getElementById('home-hero')) {
    initHome();
  }


  if ( document.querySelector('.with-line')) {
    var lineContainer = document.createElement('div');
    lineContainer.className = 'line-container';
    lineContainer.innerHTML = '<svg width="1021" height="445" viewBox="0 0 1021 445" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 323.652H379.923C407.537 323.652 429.923 301.266 429.923 273.652V201.348C429.923 173.734 452.309 151.348 479.923 151.348H482.905C510.52 151.348 532.905 173.734 532.905 201.348V393C532.905 420.614 555.291 443 582.905 443H587.947C615.562 443 637.947 420.614 637.947 393V52C637.947 24.3858 660.333 2 687.947 2H695.049C722.663 2 745.049 24.3858 745.049 52V213.652C745.049 241.266 767.435 263.652 795.049 263.652H804.21C831.825 263.652 854.21 241.266 854.21 213.652V186.457C854.21 158.842 876.596 136.457 904.21 136.457H911.312C938.926 136.457 961.312 158.842 961.312 186.457V273.652C961.312 301.266 983.698 323.652 1011.31 323.652H1503" stroke="#CECAF2" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    if ( document.querySelector('.with-line').classList.contains('with-line-vertical') ) {
      lineContainer.classList.add('vertical');
      lineContainer.innerHTML = '<svg width="390" height="1063" viewBox="0 0 390 1063" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M106.463 -1.23064e-05L106.463 71.6148C106.463 99.229 128.849 121.615 156.463 121.615L212.202 121.615C237.097 121.615 257.278 141.796 257.278 166.691V166.691C257.278 191.586 237.097 211.767 212.202 211.767L47.9776 211.767C22.5849 211.767 2 232.352 2 257.744V257.744C2 283.137 22.5849 303.722 47.9776 303.722L341.121 303.722C367.012 303.722 388 324.711 388 350.601V350.601C388 376.492 367.012 397.48 341.121 397.48L206.761 397.48C180.372 397.48 158.98 418.872 158.98 445.261V445.261C158.98 471.649 180.372 493.041 206.761 493.041L223.433 493.041C249.324 493.041 270.312 514.03 270.312 539.921V539.921C270.312 565.811 249.324 586.8 223.433 586.8L156.463 586.8C128.849 586.8 106.463 609.185 106.463 636.8L106.463 1061" stroke="#CECAF2" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    }
    document.querySelector('.page__article').append(lineContainer);
    gsap.set('.line-container svg path', { drawSVG:0 })
    gsap.to('.line-container svg path', { drawSVG:'100%', duration:5, ease:'Power3.easeOut', delay:4.5 })
  }

}



function initHome() {
  //console.log('Home initialized')
  //config.BLOOM_INTENSITY = 20;

  document.querySelectorAll('svg .white').forEach(function(e){
    const greenElt = e.cloneNode();
    greenElt.setAttribute('class', greenElt.classList.contains('ebar')?'green ebar':'green' );
    e.parentNode.append(greenElt)
  })
  document.querySelectorAll('svg .white').forEach(function(e){
    const darkElt = e.cloneNode();
    darkElt.setAttribute('class', darkElt.classList.contains('ebar')?'dark ebar':'dark' );
    e.parentNode.append(darkElt)
  })
  
  document.querySelectorAll('#home-hero .home-hero__anim p').forEach((_this) => {
    const textsWords = _this.querySelectorAll('.word');
   
    gsap.set(textsWords,{
      opacity:0,
      y:100,
    })
  });

  gsap.set('.conic-scroll', { opacity:0, scale:0 })
  gsap.set('.conic-candidate', { opacity:0, scale:0 })

  gsap.set('.talent .white', {drawSVG:"0%"})
  gsap.set('.talent .green', {drawSVG:"0%"})
  gsap.set('.talent .dark', {drawSVG:"0%"})
  
  gsap.set('.home-hero__anim svg.line .white',  {drawSVG:"0%"})
  gsap.set('.home-hero__anim svg.line .green',  {drawSVG:"0%"})
  gsap.set('.home-hero__anim svg.line .dark',  {drawSVG:"0%"})
  
  gsap.set('.home-hero__anim svg.mobile-line .white',  {drawSVG:"0%"})
  gsap.set('.home-hero__anim svg.mobile-line .green',  {drawSVG:"0%"})
  gsap.set('.home-hero__anim svg.mobile-line .dark',  {drawSVG:"0%"})

  gsap.set('.border .white',  {drawSVG:"0%"})
  gsap.set('.border .green',  {drawSVG:"0%"})
  gsap.set('.border .dark',  {drawSVG:"0%"})
  
  gsap.set('.home-hero__content p .word, .home-hero__content .button', {
    opacity:0,
    y:200,
  })
}

function loadPage(){
  gsapAnimations()
  loadBoxes();
  loadBigTitles();
  loadCategories();
  loadPartners();
  loadTimeline();
  loadFaq();
  loadModals();
  loadCandidate();
  loadScrollInvite();
  loadFormModals();
}

function loadScrollInvite() {
  if( document.getElementById('the-content')) {
    var pos = document.getElementById('the-content').querySelector('.elementor > section:first-child ').getBoundingClientRect();
    gsap.set('.conic-scroll', { top : pos.height + 250 });
  } else {
    gsap.set('.conic-scroll', { top : '80vh' });
  }
  gsap.to('.conic-scroll', {
    opacity:1,
    scale:1,
    delay: document.getElementById('home-hero') ? 3 : 1,
    onComplete:function(){
      gsap.to('.conic-scroll', {
        scrollTrigger:{
          trigger:'body',
          start:10,
          end: 150,
          scrub: true
        },
        opacity:0,
        scale:0,
      });
    }
  })
  gsap.to('.conic-candidate', {
    opacity: 1,
    scale: 1,
    scrollTrigger: {
      trigger: document.body,
      start: "top top", 
      end: "+=100", 
      scrub: true, 
    }
  });
}


function addPointer(e) {
    var posX = scaleByPixelRatio(e.pageX);
    var posY = scaleByPixelRatio(e.clientY);
    var pointer = pointers.find(function (p) { return p.id == -1; });
    if (pointer == null)
        { pointer = new pointerPrototype(); }
    updatePointerDownData(pointer, -1, posX, posY);
}

function movePointer(e) {
    var pointer = pointers[0];
    if (!pointer.down) { return; }
    var posX = scaleByPixelRatio(e.pageX);
    var posY = scaleByPixelRatio(e.clientY);
    updatePointerMoveData(pointer, posX, posY);
}

function removePointer(e) {
  updatePointerUpData(pointers[0]);
}


function loadHome() {
  console.log('loadHome')

  //custom handler 
  if ( document.getElementById('home-hero') && isMouseSplat == true ) {
    // restart anim 
    gsap.to('.page__wrapper > canvas', {opacity:1})

    if ( typeof config !== 'undefined' ) {
      config.PAUSED = false;
      config.STARTED = true;
      update();
      
      const triggerElement = document.getElementById('home-hero');
      triggerElement.addEventListener('mouseenter', addPointer);
      triggerElement.addEventListener('mousemove',movePointer)
      triggerElement.addEventListener('mouseleave', removePointer);
    }

  }
  //eof custom handler 



  document.querySelectorAll('#home-hero .home-hero__anim p').forEach((_this) => {
    const textsWords = _this.querySelectorAll('.word');
       const pTl = gsap.timeline({paused:true})
    .to(textsWords,{
      opacity:1,
      y:0,
      stagger:0.02,
      duration:1,
      delay:2 
    })
    ScrollTrigger.create({
      trigger: _this,
      start: "top 75%",
      toggleActions:"play none none reverse",
      animation:pTl
    });
  });

  let block = {};
  block.size = 0;
  const loadingDelay = 0;
  gsap.to('.talent .white', {drawSVG:'100%', duration:0.2, stagger:0.1, ease:'Power3.easeout', delay:1 + loadingDelay, onComplete:function(){
    document.querySelectorAll('.talent .white').forEach(function(e){
      e.remove();
    })
  }})
  gsap.to('.talent .green', {drawSVG:'100%', duration:0.2, stagger:0.1, ease:'Power3.easeout', delay:1.05 + loadingDelay, onComplete:function(){
    document.querySelectorAll('.talent .green').forEach(function(e){
      e.remove();
    })
  }})
  gsap.to('.talent .dark', {drawSVG:'100%', duration:0.2, stagger:0.1, ease:'Power3.easeout', delay:1.1 + loadingDelay})
  gsap.set(['.talent #N','.talent #T2'], {x:110, duration:3 })

  const E = document.getElementById('E');
  const eTimeline = gsap.timeline({ yoyo:true, repeat:-1, timeScale:0.1, delay:4 + loadingDelay })
  .to(['.talent #N','.talent #T2'], {x:0, ease:"Power2.easeInOut", duration:4 })
  .to(E.querySelectorAll('.ebar'),{ drawSVG:'40%', ease:"Power2.easeInOut", duration:4 },'<');

  gsap.to('.home-hero__anim svg.mobile-line .white, .home-hero__anim svg.mobile-line .green, .home-hero__anim svg.mobile-line .dark',{drawSVG:'29%', duration:1, ease:'Power3.easeout', delay:3.5 + loadingDelay, stagger:0.3 });
  gsap.to('.home-hero__anim svg.line .white, .home-hero__anim svg.line .green, .home-hero__anim svg.line .dark', {drawSVG:'29%', duration:1, ease:'Power3.easeout', delay:3.5 + loadingDelay, stagger:0.3, onComplete:function(){
      
      gsapScrollSmootherState("play");

      const lineTl = gsap.timeline()
      .to(['.home-hero__anim svg.line path','.home-hero__anim svg.mobile-line path'],{
        scrollTrigger:{
          trigger:'.home-hero__anim svg.line',
          start:'top center+='+window.outerHeight / 4,
          end:'bottom center',
          scrub:true,
          onEnterBack: () => {
            /*gsap.to('.border .white', {drawSVG:'0%', duration:0.2, stagger:0.1, ease:'Power3.easeout', delay:0})
            gsap.to('.border .green', {drawSVG:'0%', duration:0.2, stagger:0.1, ease:'Power3.easeout', delay:0.05})*/
            gsap.to('.border .dark', {drawSVG:'0%', duration:0.2, stagger:0.1, ease:'Power3.easeout', delay:0.1})
          }
        },
        drawSVG:'100%',
        onComplete:function(){

          gsap.to('.border .white', {drawSVG:'100%', duration:0.2, stagger:0.1, ease:'Power3.easeout', delay:0, onComplete:function(){
            document.querySelectorAll('.border .white').forEach(function(e){
              e.remove();
            })
          }})
          gsap.to('.border .green', {drawSVG:'100%', duration:0.2, stagger:0.1, ease:'Power3.easeout', delay:0.05, onComplete:function(){
            document.querySelectorAll('.border .green').forEach(function(e){
              e.remove();
            })
          }})
          gsap.to('.border .dark', {drawSVG:'100%', duration:0.2, stagger:0.1, ease:'Power3.easeout', delay:0.1, onComplete:function(){
            
            
            const O = document.getElementById('O2');
            O.querySelectorAll('.green, .white').forEach(function(e){
              e.remove(); 
            })
            const oTimeline = gsap.timeline({ yoyo:true, repeat:-1, timeScale:0.1, delay:0 })
            .to(['.border #O2 .start path','.border #B'], {x:106, ease:"Power2.easeInOut", duration:4 })
            .set(O.querySelectorAll('.middle'),{ transformOrigin:'110px 0' },'<')
            .to(O.querySelectorAll('.middle'),{ scaleX:0.05, ease:"Power2.easeInOut", duration:4 },'<');

            ScrollTrigger.create({
              trigger: ".award-boxes",
              start: "top center",
              onToggle: function(self){ 
                  console.log(self.isActive);
                 if ( self.isActive) { 
                  eTimeline.pause(); 
                  oTimeline.pause(); 
                  // document.querySelector('#gradient-background').pause();
                } 
                 else { 
                  eTimeline.play(); 
                  oTimeline.play(); 
                  // document.querySelector('#gradient-background').play();
                } 
                },
            });
          }})

          gsap.to('.home-hero__content p .word, .home-hero__content .button', {
            opacity:1,
            y:0,
            delay:2,
            duration:0.5,
            stagger:0.02
          })

        },
        stagger:0.03,
      })

    }})

}

function loadBigTitles() {
  // BIG-TITLE 
  if ( !isMobile() && elasticsLetters ) {
    const elastics = document.querySelectorAll('.elastic');
    elastics.forEach(function(elastic){
      let pc = 12;
      let offset = -90;
      let offsetEnd = -90;
      let offsetRight = 90;
      let offsetEndRight = '400%';
      if ( elastic.dataset.pc ) pc = elastic.dataset.pc;
      if ( isMobile() && window.innerWidth < 992 ) {
        offset = '-11vw';
        offsetEnd = '-400%';
        if ( elastic.dataset.pc ) {
          offsetRight = '-500%';
          offsetEndRight = '500%';
        }
      }

      if ( elastic.dataset.direction && elastic.dataset.direction == 'right' ) {

        const elasticTimeline = gsap.timeline({ yoyo:true, repeat:-1, timeScale:0.1 })
        .to(elastic.querySelectorAll('.between'),{ drawSVG: pc+'%', x:'90%', ease:"Power2.easeInOut", duration:4 },'<')
        .to(elastic.querySelector('.start'), {x: offsetEndRight, ease:"Power2.easeInOut", duration:4 },'<')
        .to(elastic.parentNode.previousSibling, {x: offsetRight, ease:"Power2.easeInOut", duration:4 },'<')

        return;
      } 

      const elasticTimeline = gsap.timeline({ yoyo:true, repeat:-1, timeScale:0.1 })
      .to(elastic.querySelectorAll('.between'),{ drawSVG:pc+'%', ease:"Power2.easeInOut", duration:4 },'<')
      .to(elastic.querySelector('.end'), {x:offsetEnd, ease:"Power2.easeInOut", duration:4 },'<')
      .to(elastic.parentNode.nextSibling, {x:offset, ease:"Power2.easeInOut", duration:4 },'<')
    })
  }
}
function loadBoxes() {
  if ( document.querySelector('.award-boxes')) {


    let mm = gsap.matchMedia()
    
    

    document.querySelectorAll('.award-boxes .box').forEach(function(box){

      
      if ( box.classList.contains('primary')) {

        //box icon 
        gsap.set('.box.primary .box__icon path',{drawSVG:0});
        gsap.set('.box.primary .box__icon .ellipse-3',{y:-5});
        box.boxIconTl = gsap.timeline({paused:true, yoyo:true, repeatDelay: 1, defaults:{duration:1}})
        .to('.box.primary .box__icon .ellipse-3',{
          y:0,
          duration:1
        })
        .to('.box.primary .box__icon .path-1',{
          drawSVG:'100%'
        }, '<')
        .to('.box.primary .box__icon .path-2',{
          drawSVG:'100%'
        }, '<');

      }
      else if ( box.classList.contains('secondary')) {
        gsap.set(['.box.secondary .box__icon path:nth-child(4)','.box.secondary .box__icon path:nth-child(3)','.box.secondary .box__icon path:nth-child(2)'],{scale:0});
        gsap.set('.box.secondary .box__icon path:nth-child(1)',{drawSVG:0});
        box.boxIconTl = gsap.timeline({paused:true, yoyo:true, repeatDelay: 1, defaults:{duration:1}})
        .to('.box.secondary .box__icon path:nth-child(1)',{
          drawSVG:'100%',
          duration:1
        },'<')
        .to('.box.secondary .box__icon path:nth-child(2)',{
          scale:1,
          duration:0.2,
        }, '>-0.4')
        .to('.box.secondary .box__icon path:nth-child(3)',{
          scale:1,
          duration:0.3,
        }, '<+0.2')
        .to('.box.secondary .box__icon path:nth-child(4)',{
          scale:1,
          duration:0.3,
        }, '<+0.3')
      } else if (box.classList.contains('tertiary')) {

        gsap.set('.box.tertiary .box__icon path',{ drawSVG:0 });
        box.boxIconTl = gsap.timeline({paused:true, yoyo:true, defaults:{duration:1}})
        .to('.box.tertiary .box__icon path',{
          drawSVG:'100%',
          duration:1
        })

      }
      
      gsap.set(box, {opacity:0, y:100 });
      
      const boxTl = gsap.timeline({paused:true, defaults:{ease:'Power3.easeInOut', duration:1, stagger:0.05,}})
      .to(box, {
        opacity:1, 
        y:0,
        onComplete:function(){
          box.boxIconTl.restart();
        }
      });
	
          
      mm.add("(max-width: 799px)", () => {
        // mobile setup code here...
        ScrollTrigger.create({
          trigger:box,
          start:"top 70%",
          end:"bottom-=200 30%",
          toggleActions:"play none none reverse",
          animation:boxTl,
        })
      });
        

      const arrowTimeline = gsap.timeline({paused: true});
      arrowTimeline
      .to(box.querySelector('.box__arrow'), {
        y:0, 
        x:0,
        duration:0.3,
        ease:'Power3.easeOut'
      })
      .to(box.querySelector('.box__arrow path:nth-child(3)'), {
        drawSVG:"100%",
        duration:0.3,
        ease:'Power3.easeOut',
      }, '<')
      .to(box.querySelector('.box__arrow path:nth-child(2)'), {
        drawSVG:"100%",
        duration:0.3,
        ease:'Power3.easeOut',
      }, '-=0.2')
      .to(box.querySelector('.box__arrow path:nth-child(1)'), {
        drawSVG:"100%",
        duration:0.3,
        ease:'Power3.easeOut'
      }, '<');


      box.addEventListener('mouseover',function(){
        arrowTimeline.play();
        box.boxIconTl.repeat(-1);
        box.boxIconTl.repeatDelay(1);
        box.boxIconTl.yoyo(true);
        box.boxIconTl.play(0);
      })
      box.addEventListener('mouseout',function(){
        arrowTimeline.reverse();
        box.boxIconTl.repeat(0);
      })

    })

    // large
    mm.add("(min-width: 800px)", () => {
      // desktop setup code here...
      gsap.utils.toArray(".award-boxes .box").forEach((item, i) => {
        gsap.to(item, {
          scrollTrigger:{
            trigger:'.award-boxes',
            start:"top 70%",
            end:"bottom-=200 30%",
          },
          opacity:1,
          y:0,
          delay: i * 0.2,
          onComplete() {
            item.boxIconTl.restart();
          }
        })
      })
    })

//



    // box arrow
    if ( !isMobile() ) {
      gsap.set('.award-boxes .box__arrow path',  {drawSVG:"0%"});
      gsap.set('.award-boxes .box__arrow', {y:20, x:-20})
    }
      
    document.querySelectorAll('.award-boxes .box').forEach(function(box){

    })

    if ( typeof VanillaTilt !== 'undefined' && window.innerWidth > 992 ) {
      VanillaTilt.init(document.querySelectorAll(".tilted"));
    }

  }
}

const conicCursor = document.querySelector('.conic-cursor');
const cursorTl = gsap.timeline({paused: true});
cursorTl.to(conicCursor,{scale:1,alpha:1,duration:0.4})
function moveCircle(e) {
  gsap.to(conicCursor, 0.3, {
    css: {
      left: e.pageX,
      top: e.clientY
    }
  });
}


function loadCategories() {
  if ( document.querySelector('.award-categories') ) {

    // cursor 
    const cursorWrapper = document.querySelector('.award-categories__items'); 
    cursorWrapper.addEventListener('mouseover',function(){
      conicCursor.querySelector('.conic-cursor__text').innerHTML = cursorWrapper.dataset.cursorText;
      cursorTl.play();
      cursorWrapper.addEventListener('mousemove', moveCircle);
    });
    cursorWrapper.addEventListener('mouseout',function(){
        cursorTl.reverse();
    });
    //eof cursor


  // AWARD CATEGORIES

    // ANIMATIONS ON SCROLL
    gsap.set('.award-categories .separator',{scaleX:0});
    gsap.set('.award-categories .award-categories__item',{opacity:0, y:100});

    const sepTl = gsap.timeline({paused:true, defaults:{ease:'Power3.easeInOut', duration:1, stagger:0.1,}})
    .to('.award-categories .separator', {
      scaleX:1, 
    })
    .to('.award-categories .award-categories__item',{
      opacity:1, 
      y:0,
    },'<');

    sepTl.play();
    ScrollTrigger.create({
      trigger:'.award-categories__items',
      start:"top 70%",
      end:"bottom 20%",
      toggleActions:"play none none reverse",
      animation:sepTl,
    })



    // HOVER BTNS 
    const accordionBtns = document.querySelectorAll(".award-categories__item");
    let accordionFlag = 0; 
    gsap.set('.award-categories__item__arrow path',  {drawSVG:"0%"});


    accordionBtns.forEach((accordion) => {

      const arrowTimeline = gsap.timeline({paused: true});
      arrowTimeline
      .to(accordion.querySelector('.award-categories__item__arrow'), {
        y:0, 
        x:0,
        duration:0.3,
        ease:'Power3.easeOut'
      })
      .to(accordion.querySelector('.award-categories__item__arrow path:nth-child(3)'), {
        drawSVG:"100%",
        duration:0.3,
        ease:'Power3.easeOut',
      }, '<')
      .to(accordion.querySelector('.award-categories__item__arrow path:nth-child(2)'), {
        drawSVG:"100%",
        duration:0.3,
        ease:'Power3.easeOut',
      }, '-=0.2')
      .to(accordion.querySelector('.award-categories__item__arrow path:nth-child(1)'), {
        drawSVG:"100%",
        duration:0.3,
        ease:'Power3.easeOut'
      }, '<');


      let content = accordion.querySelector('.award-categories__item__text');
      accordion.addEventListener('mouseover', function (e) {
        if ( !accordionFlag ) {
          accordionFlag = 1;

          document.querySelectorAll('.award-categories__item .award-categories__item__text').forEach(function(content){
            content.style.maxHeight = 0; 
          })
          content.style.maxHeight = content.scrollHeight + "px";

          arrowTimeline.play();

          setTimeout(function(){ accordionFlag = 0 }, 50);
        }
      });

      
      accordion.addEventListener('mouseout', function (e) {
        arrowTimeline.reverse();
      });
    });
  }
}

// PARTNERS
function loadPartners(){
  if ( document.querySelector('.section-partners') ) {
    document.querySelectorAll('.section-partners .partner').forEach(function(partner, index){
      const linePath = partner.querySelector('path');
      gsap.set(linePath, {drawSVG:"0%"})
      gsap.to(linePath, {
        scrollTrigger:{
          trigger:partner,
          start:'top center',
          end:'bottom center',
          scrub:true,
        },
        drawSVG:(index==1?'-':'')+'100%', 
        duration:0.2, 
        stagger:0.1, 
        ease:'Power3.easeout', 
        delay:1.1
      })
    })
  }
}

//TIMELINE
function loadTimeline() {
  if (document.querySelector('.award-timeline')) {
    var section = document.querySelector(".award-timeline");
    var cheminSVG = section.querySelector("path");
    gsap.set(cheminSVG, { drawSVG: "0%" });
    gsap.set('.award-timeline__line', { scaleX: 0 });
    
    const timelineTl = gsap.timeline({ paused: true })
      .to(cheminSVG, {
        duration: 2,
        drawSVG: "100%",
        ease: "power2.inOut"
      })
      .to('.award-timeline__line', {
        scaleX: 1,
        stagger:0.2
      }, "-=0.5"); 
    
    ScrollTrigger.create({
      trigger: section,
      start: "top 70%",
      toggleActions: "play none none reverse",
      animation: timelineTl
    });
  }
}


// FAQ
function loadFaq(){
  if ( document.querySelector('.section-faq') ) {

    gsap.set('.faq-item', { opacity:0 })
    setTimeout(function(){
      gsap.set('.faq-item', { opacity:0, y:100 })
      const faqTl = gsap.timeline({paused:true})
      .to('.faq-item', {
        opacity:1, 
        y:0,
        ease:'Power3.easeOut',
        duration:0.5,
        stagger:0.1,
      });
      ScrollTrigger.create({
        trigger:'#faq0',
        start:"top center+="+window.innerHeight/4,
        toggleActions:"play none none reverse",
        animation:faqTl,
      })
    },200)
  }
}
// CANDIDATE BIG BUTTON
function loadCandidate(){
  if ( document.querySelector('.section-candidate') ) {

    const candidateTl = gsap.timeline({paused:true});
    gsap.set('.section-candidate > div', { clipPath:'polygon(0% 101%, 100% 101%, 100% 101%, 0% 101%)' })
    candidateTl.to('.section-candidate > div', {
      clipPath:'polygon(0% 0%, 100% 0%, 100% 101%, 0% 101%)',
      ease:'Power3.easeOut',
      duration:1
    })
    ScrollTrigger.create({
      trigger:'.section-candidate',
      start:"bottom 100%",
      toggleActions:"play none none reverse",
      animation:candidateTl
    })

    const arrowTimeline = gsap.timeline();
    const bigCandidateBtn = document.querySelector('.candidate-button');
    if ( !isMobile() ) gsap.set(bigCandidateBtn.querySelectorAll('.candidate-button__arrow path'),{drawSVG:"0%"})
    arrowTimeline
    .to(bigCandidateBtn.querySelector('.candidate-button__arrow'), {
      y:0, 
      x:0,
      duration:0.3,
      ease:'Power3.easeOut'
    })
    .to(bigCandidateBtn.querySelector('.candidate-button__arrow path:nth-child(3)'), {
      drawSVG:"100%",
      duration:0.3,
      ease:'Power3.easeOut',
    }, '<')
    .to(bigCandidateBtn.querySelector('.candidate-button__arrow path:nth-child(2)'), {
      drawSVG:"100%",
      duration:0.3,
      ease:'Power3.easeOut',
    }, '-=0.2')
    .to(bigCandidateBtn.querySelector('.candidate-button__arrow path:nth-child(1)'), {
      drawSVG:"100%",
      duration:0.3,
      ease:'Power3.easeOut'
    }, '<')
    arrowTimeline.pause();
    bigCandidateBtn.addEventListener('mouseover',function(){
      arrowTimeline.play();
    })
    bigCandidateBtn.addEventListener('mouseout',function(){
      arrowTimeline.reverse();
    })
  }
}


gsap.to('.footer__navbar__nav .footer__navbar__menu .menu__item', { opacity:0, y:-100} );
const footerItemsTl = gsap.timeline({paused:true}).to('.footer__navbar__nav .footer__navbar__menu .menu__item', { opacity:1, y:0, stagger:-0.2 } );
ScrollTrigger.create({
  trigger:'.footer__navbar__nav .footer__navbar__menu',
  start:'top 80%',
  animation:footerItemsTl,
  toggleActions:'play none none reverse'
})



function loadModals() {

  if ( document.querySelector('.open-modal') ) {
    const modals = [new Modal('#modal-1'), new Modal('#modal-2'), new Modal('#modal-3'), new Modal('#modal-4'), new Modal('#modal-5')];

    document.querySelectorAll('.open-modal a').forEach(function(modalLink, index) {
      modalLink.addEventListener('click',function(e){
        e.preventDefault();
        const href = e.target.href.substring(e.target.href.lastIndexOf('/') + 1).substring(1);
        console.log(index)
        modals[index].show();

      })
    })
  }
}


window.onload = (event) => {
  if ( document.querySelector('.page__preloader') ) {

    document.querySelectorAll('a:not([target=_blank])').forEach(function(e){
      if ( !e.href.includes("#")) {
        e.addEventListener('click',function(){
          let transitionTl = gsap.timeline()
          /*.set('.page__preloader .conic-gradient',{
            opacity:0,
          })*/
          .to('.page__preloader', {
            scale:1,
            duration:0.3,
            ease:'Power2.easeIn'
          })
          .to('.page__preloader .preloader__background', {
            width:'100%',
            height:'100%',
            left:0,
            top:0,
          }, '<')
          .to('.page__preloader .preloader__background', {
            borderRadius:0,
            duration:0.2,
            delay:0.1,
            ease:'Power3.easeIn'
          }, '<')
          
          setTimeout(function(){
            transitionTl.reverse();
          }, 1000)
        })
      }
    })
  }
};


var inputs = document.querySelectorAll( '.wpcf7-file' );
Array.prototype.forEach.call( inputs, function( input )
{
	var label	 = input.parentNode.nextElementSibling,
		labelVal = label.innerHTML;

    console.log(label);
	input.addEventListener( 'change', function( e )
	{
		var fileName = '';
		if( this.files && this.files.length > 1 )
			fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
		else {
			fileName = e.target.value.split( '\\' ).pop();
    }

		if( fileName )
			label.querySelector( 'strong' ).innerHTML = fileName;
		else
			label.innerHTML = labelVal;
	});
});

function loadFormModals() {
  if ( document.querySelector('.wpcf7')) {
    const wpcf7Elm = document.querySelector( '.wpcf7' );
    const modalSuccess = new Modal('#modal-success');
    wpcf7Elm.addEventListener('wpcf7mailsent', function (e) {
      console.log('mail sent', e.detail.apiResponse.message )
      document.querySelector('#modal-success .wpcf7-response-output').innerHTML = e.detail.apiResponse.message
      modalSuccess.show();
    });
  }
}